import React, { useEffect, useMemo, useState } from 'react';
import {
  MobileGameHolder,
  MobileGameStructure,
  MobileGameWr,
} from '@pascal/pascal-core/table-line/table-components';
import {
  DefaultQueryParams,
  GameControllers,
  iframeService,
  SidebarHolder,
  parseQuery,
  RightSideHolder,
  TableFooter,
  useTranslation,
  useUserInfoStore,
  MobileStructureMiddle,
  parseNumberByPrecision,
  OverlayFooter,
  useLobbyStore,
  tableBetHistoryStore, applicationStore, TableMobileHeader,
} from '@pascal/pascal-core';
import { MobileGameScene } from '../mobileGameScene';
import { GamePad } from '../../components/gamePad';
import { Popups } from '../../components/popups/popups';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';
import { GAME_CONTROLLER_TYPES } from '@pascal/pascal-core/shared/core/enums/gameControllerTypes';
import gameLogo from '../../assets/images/logo.png';
import { BetHistoryWrp } from '../../conatiners/betHistory';
import { useLocation, useNavigate } from 'react-router-dom';
import { gameStore } from '../../module/store/gameStore';
import { observer } from 'mobx-react-lite';
import { HelpPopup } from '../../conatiners/helpPopup';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { Settings } from '@pascal/pascal-core/table-line';
import { configStore } from '../../module/store/configStore';
import { PlayingGameMode } from '../../enums/PlayingGameMode';
import { gameService } from '../../module/gameLiveConnection/gameService';


const gameControllerComponents = {
  [GameControllerTypes.Help]: <HelpPopup />,
  [GameControllerTypes.History]: <BetHistoryWrp />,
  [GameControllerTypes.Settings]: <Settings />,
};

export const MobileGame = observer(() => {
  const [gameControllerType, setGameControllerType] = useState('');
  const { selectedHistoryRow, setSelectedHistoryRow } = tableBetHistoryStore;
  const { isTestPlatform } = applicationStore;
  const navigate = useNavigate();
  const { search } = useLocation();
  const t = useTranslation();
  const { [DefaultQueryParams.UserId]: userId } = parseQuery(search);
  const { currencyCode } = gameStore

  const navigationItems = useMemo(() => {
    const items = [
      {
        icon: 'icon-home1',
        name: t('HOME'),
        onClick: () => iframeService.redirectHome(),
      },
      {
        icon: 'icon-help',
        name: t('RULES'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HELP),
      },
      {
        icon: 'icon-history',
        name: t('HISTORY'),
        isDisabled: applicationStore.isDemo,
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HISTORY),
      },
      {
        icon: 'icon-settings',
        name: t('SETTINGS'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.SETTINGS),
      },
    ];
    if (isTestPlatform) {
      items.splice(3, 1);
      return items;
    }
    return items;
  }, [isTestPlatform, navigate, search, t, userId]);

  const GameControllerComponent = useMemo(() => {
    const component = gameControllerComponents[gameControllerType];
    if (component) {
      return component;
    }
    return null;
  }, [gameControllerType]);
  return (
    <MobileGameWr>
      <MobileGameStructure>
        <TableMobileHeader
          logoSrc={gameLogo}
          isShowFairness={false}
          isShowMinMax={false}
          demoSwitcherAdditionalFunction={() => {
            configStore.setMode(PlayingGameMode.Real);
            gameService.resetResults();
          }
          }/>
        <MobileStructureMiddle haveNotification translationValues={{}}>
          <MobileGameHolder>
            <div className="mobile-mines-game-wrapper" >
              <MobileGameScene/>
              <GamePad />
              <Popups />
            </div>
          </MobileGameHolder>
          <SidebarHolder setGameControllerType={setGameControllerType}>
            <GameControllers
              currencyCode={currencyCode}
              controllerType={gameControllerType}
              setGameControllerType={() => setGameControllerType(null)}
              selectedHistoryRow={selectedHistoryRow}
              setSelectedHistoryRow={setSelectedHistoryRow}
              gameControllerComponent={GameControllerComponent}
              hasScrollToBottom={gameControllerType === GAME_CONTROLLER_TYPES.RESULTS}
            />
          </SidebarHolder>
          <RightSideHolder navigationItems={navigationItems} />
        </MobileStructureMiddle>
        <TableFooter
          totalBet={parseNumberByPrecision(gameStore.amount, 1)}
        />
      </MobileGameStructure>
    </MobileGameWr>
  );
});